import { Page401, Page498, useStoreUIV1 } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router-dom';
import MainUse from './main';
import { Events } from './pages/events/view/events.page';
import { Vao } from './pages/vao/view/vao.page';

export const CustomRouter = observer(() => {
  const { SSOStore } = useStoreUIV1();

  const sitemap = [
    {
      path: '*',
      element: <Navigate to={`/`} />,
    },
    {
      path: '/',
      element: <MainUse />,
      children: [
        {
          path: ':id',
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <Events />,
            },
            {
              path: 'events',
              element: <Events />,
            },
            {
              path: 'vao',
              element: <Vao />,
            },
            // {
            //   path: 'occupancy',
            //   element: <Occupancy />,
            // },
          ],
        },
      ],
    },
  ];

  return SSOStore?.error === 'UNAUTHORIZED' ? (
    <Page401 />
  ) : SSOStore.authenticated && SSOStore.user ? (
    <RouterProvider router={createBrowserRouter(sitemap)}></RouterProvider>
  ) : (
    <Page498 />
  );
});
